import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MeuPerfilEditarPageRoutingModule } from './meu-perfil-editar-routing.module';
import { MeuPerfilEditarPage } from './meu-perfil-editar.page';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipesModule,
    MeuPerfilEditarPageRoutingModule
  ],
  declarations: [MeuPerfilEditarPage]
})
export class MeuPerfilEditarPageModule {}
